import { jsx as t, jsxs as v, Fragment as W } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as Le, AlertActionCloseButton as nn, Page as rn, Modal as Ct, ModalVariant as an, TextContent as ln, Text as Ce, Button as V, Spinner as kt, FormHelperText as He, HelperText as We, HelperTextItem as je, Popover as on, Icon as Be, FormGroup as It, NumberInput as sn, ValidatedOptions as z, InputGroup as xe, InputGroupItem as Ne, TextInput as Se, Select as Te, SelectList as Ee, SelectOption as Ge, MenuToggle as he, MenuToggleStatus as ze, TextInputGroup as wt, TextInputGroupMain as xt, ChipGroup as Je, Chip as Ye, TextInputGroupUtilities as St, Switch as cn, TextArea as Tt, Title as dn, Card as un, CardHeader as hn, CardTitle as pn, CardBody as mn, Grid as fn, GridItem as ot, PageSection as gn, JumpLinks as yn, JumpLinksItem as bn, ButtonVariant as Ie, Checkbox as vn, Radio as Cn, MenuFooter as kn, Dropdown as In, DropdownList as wn, DropdownItem as st, Masthead as xn, MastheadToggle as Sn, PageToggleButton as Tn, MastheadBrand as En, MastheadContent as An, Toolbar as ke, ToolbarContent as Ve, ToolbarItem as H, Avatar as Rn, Bullseye as On, EmptyState as Dn, EmptyStateIcon as ct, EmptyStateHeader as Fn, EmptyStateBody as Pn, EmptyStateFooter as Mn, EmptyStateActions as Ln, SearchInput as Bn, Divider as Nn, Pagination as Vn, Badge as _n } from "@patternfly/react-core";
import { createContext as Et, useContext as At, useRef as J, useEffect as le, useCallback as ue, useState as E, useMemo as _, forwardRef as qn, useId as Rt, Fragment as Ot, Children as Dt, Component as $n, isValidElement as Kn } from "react";
import { useTranslation as q } from "react-i18next";
import { NetworkError as Ft } from "@keycloak/keycloak-admin-client";
import Un from "keycloak-js";
import { ExclamationCircleIcon as Hn, HelpIcon as dt, EyeIcon as Wn, EyeSlashIcon as jn, TimesIcon as Pt, CubeIcon as Gn, PaypalIcon as zn, InstagramIcon as Jn, BitbucketIcon as Yn, MicrosoftIcon as Qn, TwitterIcon as Xn, StackOverflowIcon as Zn, OpenshiftIcon as er, LinkedinIcon as tr, GoogleIcon as nr, GitlabIcon as rr, FacebookSquareIcon as ar, GithubIcon as lr, MinusCircleIcon as ir, PlusCircleIcon as Mt, EllipsisVIcon as or, BarsIcon as sr, SearchIcon as cr, SyncAltIcon as dr } from "@patternfly/react-icons";
import { useFormContext as Ae, Controller as ie, useController as Qe, FormProvider as ur, useWatch as hr } from "react-hook-form";
import { get as N, intersectionBy as pr, cloneDeep as mr } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as fr } from "@patternfly/react-styles";
import { Table as gr, TableVariant as yr, Thead as br, Tr as ve, Th as Pe, Tbody as ut, Td as re, ExpandableRowContent as vr, ActionsColumn as Cr, TableText as kr } from "@patternfly/react-table";
import './main.css';function Xe(e, n) {
  const r = Et(n);
  return r.displayName = e, r;
}
const Ir = ["error", "errorMessage"], Me = "error_description";
function wr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ft)
    return Lt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function xr(e) {
  if (!(e instanceof Ft))
    return;
  const n = e.responseData;
  return Sr(n);
}
function Sr(e) {
  if (typeof e == "object" && e !== null && Me in e && typeof e[Me] == "string")
    return e[Me];
}
function Lt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of Ir) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Tr = () => Math.floor(Math.random() * 1e3);
function Er(e) {
  return e != null;
}
function Ze(e) {
  const n = At(e);
  if (Er(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Ar() {
  const e = J(!1), n = J(/* @__PURE__ */ new Set());
  le(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return ue((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(o, l));
    n.current.add(i);
    function o() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Rr({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, o) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": o === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Le[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Or = 8e3, Bt = Xe(
  "AlertContext",
  void 0
), Va = () => Ze(Bt), Dr = ({ children: e }) => {
  const { t: n } = q(), r = Ar(), [a, l] = E([]), i = (c) => l((p) => p.filter((d) => d.id !== c)), o = ue(
    (c, p = Le.success, d) => {
      const y = {
        id: Tr(),
        message: c,
        variant: p,
        description: d
      };
      l((g) => [y, ...g]), r(() => i(y.id), Or);
    },
    [r]
  ), s = ue(
    (c, p) => {
      const d = n(c, { error: wr(p) }), y = xr(p);
      o(d, Le.danger, y);
    },
    [o, n]
  ), u = _(() => ({ addAlert: o, addError: s }), [o, s]);
  return /* @__PURE__ */ v(Bt.Provider, { value: u, children: [
    /* @__PURE__ */ t(Rr, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Fr = (e) => {
  const { t: n, i18n: r } = q(), a = e.error, l = Pr(a), i = Lt(a);
  console.error(a);
  function o() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    Ct,
    {
      variant: an.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(V, { variant: "primary", onClick: o, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: l ? /* @__PURE__ */ t(Ce, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(Ce, { children: n(i) }) : /* @__PURE__ */ t(Ce, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Pr(e) {
  return e instanceof Error ? e.message : null;
}
function Mr(e, n, r) {
  const [a, l] = E(
    () => e.getItem(n) ?? r
  ), i = ue((o) => {
    l(o), e.setItem(n, o);
  }, []);
  return le(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", o);
    function o(s) {
      s.storageArea === e && (s.key === null || s.key === n) && l(s.newValue ?? r);
    }
    return () => window.removeEventListener("storage", o);
  }, [e, n]), [a, i];
}
function Nt(e, n, r) {
  const a = _(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Mr(
    e,
    n,
    a
  ), o = _(() => JSON.parse(l), [l]), s = ue(
    (u) => i(JSON.stringify(u)),
    []
  );
  return [o, s];
}
const Vt = Xe(
  "HelpContext",
  void 0
), Lr = () => Ze(Vt), Br = ({ children: e }) => {
  const [n, r] = Nt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Vt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, Nr = () => Et(void 0);
let _e;
const _a = () => {
  const e = At(_e);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, qa = ({
  environment: e,
  children: n
}) => {
  _e = Nr();
  const r = J(!1), [a, l] = E(!1), [i, o] = E(), s = _(() => {
    const u = new Un({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return u.onAuthLogout = () => u.login(), u;
  }, [e]);
  return le(() => {
    if (r.current)
      return;
    s.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => l(!0)).catch((c) => o(c)), r.current = !0;
  }, [s]), i ? /* @__PURE__ */ t(Fr, { error: i }) : a ? /* @__PURE__ */ t(_e.Provider, { value: { environment: e, keycloak: s }, children: /* @__PURE__ */ t(Dr, { children: /* @__PURE__ */ t(Br, { children: n }) }) }) : /* @__PURE__ */ t(kt, {});
};
function $a() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ka = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: o,
  onContinue: s,
  component: u = V,
  children: c,
  ...p
}) => {
  const [d, y] = E(!1);
  return /* @__PURE__ */ v(W, { children: [
    /* @__PURE__ */ t(
      u,
      {
        variant: i,
        onClick: () => y(!0),
        isDisabled: l,
        "data-testrole": o,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      Ct,
      {
        variant: "small",
        ...p,
        title: e,
        isOpen: d,
        onClose: () => y(!1),
        actions: [
          /* @__PURE__ */ t(
            V,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                y(!1), s();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            V,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => y(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, _t = ({ message: e, ...n }) => /* @__PURE__ */ t(He, { ...n, children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), qt = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1
}) => {
  const { enabled: l } = Lr();
  return l ? /* @__PURE__ */ t(on, { bodyContent: e, children: /* @__PURE__ */ v(W, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (i) => i.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(Be, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
      }
    ),
    a && /* @__PURE__ */ t(Be, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
  ] }) }) : null;
};
function pe(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const ne = ({
  name: e,
  label: n,
  labelIcon: r,
  error: a,
  children: l,
  ...i
}) => /* @__PURE__ */ v(
  It,
  {
    label: n || e,
    fieldId: e,
    labelIcon: r ? /* @__PURE__ */ t(qt, { helpText: r, fieldLabelId: e }) : void 0,
    ...i,
    children: [
      l,
      a && /* @__PURE__ */ t(_t, { "data-testid": `${e}-helper`, message: a.message })
    ]
  }
), Ua = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: o }
  } = Ae();
  return /* @__PURE__ */ t(
    ne,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: o[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: s }) => {
            const u = !!r.rules?.required, c = pe(r.rules?.min), p = s.value ?? r.defaultValue, d = (y) => s.onChange(
              c !== void 0 ? Math.max(y, Number(c)) : y
            );
            return /* @__PURE__ */ t(
              sn,
              {
                ...l,
                id: e,
                value: p,
                validated: o[e] ? z.error : z.default,
                required: u,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => d(p + 1),
                onMinus: () => d(p - 1),
                onChange: (y) => {
                  const g = Number(y.currentTarget.value);
                  d(isNaN(g) ? r.defaultValue : g);
                }
              }
            );
          }
        }
      )
    }
  );
}, Vr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = q(), [l, i] = E(!0);
  return /* @__PURE__ */ v(xe, { children: [
    /* @__PURE__ */ t(Ne, { isFill: !0, children: /* @__PURE__ */ t(
      Se,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      V,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(jn, {})
      }
    )
  ] });
}, $t = qn(
  (e, n) => /* @__PURE__ */ t(Vr, { ...e, innerRef: n })
);
$t.displayName = "PasswordInput";
const Ha = (e) => {
  const { labelIcon: n, ...r } = e, a = !!pe(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: o } = Qe({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ v(
    ne,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          $t,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: o.error ? z.error : z.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(He, { children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: e.helperText }) }) })
      ]
    }
  );
}, _r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: o,
  isDisabled: s,
  onSelect: u,
  ...c
}) => {
  const {
    control: p,
    formState: { errors: d }
  } = Ae(), [y, g] = E(!1), C = pe(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    ne,
    {
      name: n,
      label: r,
      isRequired: C,
      error: N(d, n),
      labelIcon: o,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...i,
          name: n,
          control: p,
          render: ({ field: { onChange: R, value: m } }) => /* @__PURE__ */ t(
            Te,
            {
              ...c,
              variant: "default",
              onClick: () => g(!y),
              onOpenChange: () => g(!1),
              selected: ee(a) ? a.filter(
                (h) => Array.isArray(m) ? m.includes(h.key) : m === h.key
              ).map((h) => h.value) : m,
              toggle: (h) => /* @__PURE__ */ t(
                he,
                {
                  id: e || n.slice(n.lastIndexOf(".") + 1),
                  ref: h,
                  onClick: () => g(!y),
                  isExpanded: y,
                  isFullWidth: !0,
                  status: N(d, n) ? ze.danger : void 0,
                  "aria-label": r,
                  isDisabled: s,
                  children: ee(a) ? a.find(
                    (S) => S.key === (Array.isArray(m) ? m[0] : m)
                  )?.value : m
                }
              ),
              onSelect: (h, S) => {
                const T = S?.toString(), I = Array.isArray(m) ? [T] : T;
                u ? u(I, R) : R(I), g(!1);
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Ee, { "data-testid": `select-${n}`, children: [...a, ...l].map((h) => /* @__PURE__ */ t(Ge, { value: ae(h), children: et(h) ? h : h.value }, ae(h))) })
            }
          )
        }
      )
    }
  );
}, Z = (e) => et(e) ? e : e.value, qr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: o,
  placeholderText: s,
  onFilter: u,
  variant: c,
  ...p
}) => {
  const {
    control: d,
    formState: { errors: y }
  } = Ae(), [g, C] = E(!1), [R, m] = E(""), [h, S] = E(0), [T, I] = E([]), b = J(), x = pe(i.rules?.required) === !0, F = c === de.typeaheadMulti, A = _(
    () => [
      ...a.filter(
        (f) => !l.map((k) => Z(k)).includes(Z(f))
      ),
      ...l
    ],
    [l, a]
  ), B = A.filter(
    (f) => Z(f).toLowerCase().startsWith(R.toLowerCase())
  ), U = (f, k) => {
    k.value.includes(f) ? (k.onChange(k.value.filter((O) => O !== f)), ee(a) && I(
      T.filter((O) => O.key !== f)
    )) : (k.onChange([...k.value, f]), ee(A) && I([
      ...T,
      A.find((O) => O.key === f)
    ]));
  }, M = (f, k) => {
    const O = B[h];
    switch (C(!0), f.key) {
      case "Enter": {
        f.preventDefault(), m(F ? "" : Z(O)), U(ae(O), k), C(!1), S(0);
        break;
      }
      case "Tab":
      case "Escape": {
        C(!1), k.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === de.typeahead && k.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        f.preventDefault();
        let D = 0;
        f.key === "ArrowUp" && (h === 0 ? D = a.length - 1 : D = h - 1), f.key === "ArrowDown" && (h === a.length - 1 ? D = 0 : D = h + 1), S(D);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    ne,
    {
      name: n,
      label: r,
      isRequired: x,
      error: N(y, n),
      labelIcon: o,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...i,
          name: n,
          control: d,
          render: ({ field: f }) => /* @__PURE__ */ t(
            Te,
            {
              ...p,
              onOpenChange: () => C(!1),
              selected: ee(A) ? A.filter(
                (k) => Array.isArray(f.value) ? f.value.includes(k.key) : f.value === k.key
              ).map((k) => k.value) : f.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (k) => /* @__PURE__ */ t(
                he,
                {
                  ref: k,
                  id: e || n.slice(n.lastIndexOf(".") + 1),
                  variant: "typeahead",
                  onClick: () => {
                    C(!g), b.current?.focus();
                  },
                  isExpanded: g,
                  isFullWidth: !0,
                  status: N(y, n) ? ze.danger : void 0,
                  children: /* @__PURE__ */ v(wt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      xt,
                      {
                        placeholder: s,
                        value: c === de.typeahead && f.value ? ee(A) ? A.find(
                          (O) => O.key === (Array.isArray(f.value) ? f.value[0] : f.value)
                        )?.value : f.value : R,
                        onClick: () => C(!g),
                        onChange: (O, D) => {
                          m(D), u?.(D);
                        },
                        onKeyDown: (O) => M(O, f),
                        autoComplete: "off",
                        innerRef: b,
                        role: "combobox",
                        isExpanded: g,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === de.typeaheadMulti && Array.isArray(f.value) && /* @__PURE__ */ t(Je, { "aria-label": "Current selections", children: f.value.map(
                          (O, D) => /* @__PURE__ */ t(
                            Ye,
                            {
                              onClick: (oe) => {
                                oe.stopPropagation(), f.onChange(
                                  f.value.filter(
                                    ($) => $ !== ae(O)
                                  )
                                );
                              },
                              children: ee(A) ? [
                                ...A,
                                ...T
                              ].find((oe) => O === oe.key)?.value : Z(O)
                            },
                            D
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(St, { children: (!!R || f.value) && /* @__PURE__ */ t(
                      V,
                      {
                        variant: "plain",
                        onClick: () => {
                          m(""), f.onChange(F ? [] : ""), b?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (k, O) => {
                k?.stopPropagation();
                const D = O?.toString();
                F && Array.isArray(f.value) ? (m(""), U(D || "", f)) : (f.onChange(Array.isArray(f.value) ? [D] : D), C(!1));
              },
              isOpen: g,
              children: /* @__PURE__ */ t(Ee, { children: B.map((k, O) => /* @__PURE__ */ t(
                Ge,
                {
                  value: ae(k),
                  isFocused: h === O,
                  isActive: f.value.includes(Z(k)),
                  children: Z(k)
                },
                ae(k)
              )) })
            }
          )
        }
      )
    }
  );
};
var de = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(de || {});
const ee = (e) => typeof e[0] != "string", et = (e) => typeof e == "string", ae = (e) => et(e) ? e : e.key, $r = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(_r, { ...n }) : /* @__PURE__ */ t(qr, { ...n, variant: e }), qe = (e) => e && typeof e == "string" ? e.includes("${") : !1, $e = (e) => e.substring(2, e.length - 1), te = (e, n, r, a) => {
  const l = n || r, i = qe(l) ? $e(l) : l, o = a ? `${a}.${i}` : i;
  return e(o || "");
}, Ke = (e, n) => te(e, n.displayName, n.name), Kr = ["username", "firstName", "lastName", "email"], Kt = (e) => e && Kr.includes(e), Y = (e) => `${Kt(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Wa = (e) => e.replaceAll(".", "🍺"), Ur = (e) => e.replaceAll("🍺", ".");
function ja(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map(
        (i) => qe(i?.toString()) ? r($e(i)) : i
      )
    );
    n(Y(a.field), {
      message: r(
        qe(a.errorMessage) ? $e(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Re({
  required: e
}) {
  return e;
}
function Ga(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ht(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ht);
}
function ht(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const za = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const o = r ?? (n ? "false" : !1), { control: s } = Ae();
  return /* @__PURE__ */ t(
    ne,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ie,
        {
          control: s,
          name: l.name,
          defaultValue: o,
          render: ({ field: { onChange: u, value: c } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": Ur(l.name),
              label: e,
              isChecked: n ? c === "true" : c,
              onChange: (p, d) => {
                const y = n ? d.toString() : d;
                l.onChange?.(p, d), u(y);
              }
            }
          )
        }
      )
    }
  );
}, Ja = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = Qe({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    ne,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        Tt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? z.error : z.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Ya = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!pe(e.rules?.required), i = e.defaultValue ?? "", { field: o, fieldState: s } = Qe({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ v(
    ne,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          Se,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: s.error ? z.error : z.default,
            isDisabled: e.isDisabled,
            ...a,
            ...o
          }
        ),
        r && /* @__PURE__ */ t(He, { children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: r }) }) })
      ]
    }
  );
}, Hr = Tt, Qa = ({ icon: e }) => {
  const n = Wr(e);
  return /* @__PURE__ */ t(Be, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function Wr(e) {
  switch (e) {
    case "github":
      return lr;
    case "facebook":
      return ar;
    case "gitlab":
      return rr;
    case "google":
      return nr;
    case "linkedin":
    case "linkedin-openid-connect":
      return tr;
    case "openshift-v4":
      return er;
    case "stackoverflow":
      return Zn;
    case "twitter":
      return Xn;
    case "microsoft":
      return Qn;
    case "bitbucket":
      return Yn;
    case "instagram":
      return Jn;
    case "paypal":
      return zn;
    default:
      return Gn;
  }
}
const jr = "_title_180i0_2", Gr = {
  title: jr
}, Ut = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  dn,
  {
    headingLevel: r,
    size: a,
    className: Gr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), zr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = Rt();
  return /* @__PURE__ */ v(un, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(hn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t(Ut, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__body", children: n })
  ] });
}, Jr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ v(W, { children: [
    /* @__PURE__ */ t(Ut, { id: a, title: n }),
    r
  ] }) });
}, Yr = "_panel_1cdve_1", Qr = "_sticky_1cdve_5", pt = {
  panel: Yr,
  sticky: Qr
}, Xr = "kc-main-content-page-container", mt = (e) => e.replace(/\s+/g, "-"), Zr = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = _(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ v(fn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(ot, { md: 8, sm: 12, children: l.map(({ title: i, panel: o }) => {
      const s = mt(i.toLowerCase());
      return /* @__PURE__ */ t(Ot, { children: r ? /* @__PURE__ */ t(
        zr,
        {
          scrollId: s,
          title: i,
          className: pt.panel,
          children: o
        }
      ) : /* @__PURE__ */ t(Jr, { scrollId: s, title: i, children: o }) }, i);
    }) }),
    /* @__PURE__ */ t(ot, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(gn, { className: pt.sticky, children: /* @__PURE__ */ t(
      yn,
      {
        isVertical: !0,
        scrollableSelector: `#${Xr}`,
        label: e,
        offset: 100,
        children: l.map(({ title: i }) => {
          const o = mt(i.toLowerCase());
          return /* @__PURE__ */ t(
            bn,
            {
              onClick: () => {
                const s = document.getElementById(o);
                s && s.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${o}`,
              children: i
            },
            i
          );
        })
      }
    ) }) })
  ] });
}, ea = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, Xa = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  V,
  {
    variant: "primary",
    isDisabled: e && !ea(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), ta = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, na = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = _(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, ta(i) ?? i)
    })).sort((i, o) => i.value.localeCompare(o.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(ur, { ...n, children: /* @__PURE__ */ t(
    $r,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, me = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = te(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: o }
  } = n, s = a?.(r), u = N(o, Y(r.name));
  return /* @__PURE__ */ v(
    It,
    {
      label: Ke(e, r) || "",
      fieldId: r.name,
      isRequired: Re(r),
      labelIcon: i ? /* @__PURE__ */ t(qt, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        s ? /* @__PURE__ */ v(xe, { children: [
          l,
          s
        ] }) : l,
        u && /* @__PURE__ */ t(
          _t,
          {
            "data-testid": `${r.name}-helper`,
            message: u.message
          }
        )
      ]
    },
    r.name
  );
}, ra = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(me, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  aa,
  {
    t: e,
    form: n,
    "aria-label": Ke(e, r),
    name: Y(r.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: Ke(e, r)
    }),
    ...l
  }
) }), aa = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: o,
  id: s,
  ...u
}) => {
  const { register: c, setValue: p, control: d } = a, y = hr({
    name: n,
    control: d,
    defaultValue: o || ""
  }), g = _(() => Array.isArray(y) && y.length !== 0 ? y : o || [""], [y]), C = (T) => {
    h([...g.slice(0, T), ...g.slice(T + 1)]);
  }, R = () => {
    h([...g, ""]);
  }, m = (T, I) => {
    h([...g.slice(0, T), I, ...g.slice(T + 1)]);
  }, h = (T) => {
    const I = T.flatMap((b) => b);
    p(n, I, {
      shouldDirty: !0
    });
  }, S = r.startsWith("html") ? r.substring(6) : "text";
  return le(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: s, children: g.map((T, I) => /* @__PURE__ */ v(Ot, { children: [
    /* @__PURE__ */ v(xe, { children: [
      /* @__PURE__ */ t(Ne, { isFill: !0, children: /* @__PURE__ */ t(
        Se,
        {
          "data-testid": n + I,
          onChange: (b, x) => m(I, x),
          name: `${n}.${I}.value`,
          value: T,
          isDisabled: i,
          type: S,
          ...u
        }
      ) }),
      /* @__PURE__ */ t(Ne, { children: /* @__PURE__ */ t(
        V,
        {
          "data-testid": "remove" + I,
          variant: Ie.link,
          onClick: () => C(I),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: g.length === 1 || i,
          children: /* @__PURE__ */ t(ir, {})
        }
      ) })
    ] }),
    I === g.length - 1 && /* @__PURE__ */ v(
      V,
      {
        variant: Ie.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !T || i,
        children: [
          /* @__PURE__ */ t(Mt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, I)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Re(a), i = r.startsWith("multiselect"), o = i ? vn : Cn, s = a.validators?.options?.options || [], u = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    ie,
    {
      name: Y(a.name),
      control: n.control,
      defaultValue: "",
      render: ({ field: p }) => /* @__PURE__ */ t(W, { children: s.map((d) => /* @__PURE__ */ t(
        o,
        {
          id: d,
          "data-testid": d,
          label: te(e.t, u[d], d, c),
          value: d,
          isChecked: p.value.includes(d),
          onChange: () => {
            i ? p.value.includes(d) ? p.onChange(
              p.value.filter((y) => y !== d)
            ) : p.onChange([...p.value, d]) : p.onChange([d]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        d
      )) })
    }
  ) });
}, la = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: o,
  width: s,
  maxHeight: u,
  toggleIcon: c,
  className: p,
  isDisabled: d,
  children: y,
  ...g
}) => {
  const [C, R] = E(!1), m = J(), h = () => {
    R(!C), n(!C);
  }, S = () => i === "parent" && m.current?.parentElement || "inline", T = Dt.toArray(
    y
  );
  return /* @__PURE__ */ t(
    Te,
    {
      ref: m,
      maxMenuHeight: we(u),
      isScrollable: !0,
      popperProps: {
        appendTo: S(),
        direction: o,
        width: we(s)
      },
      ...g,
      onClick: h,
      onOpenChange: (I) => {
        I !== C && h();
      },
      selected: a,
      onSelect: (I, b) => {
        r?.(b || ""), h();
      },
      toggle: (I) => /* @__PURE__ */ t(
        he,
        {
          id: e,
          ref: I,
          className: p,
          onClick: h,
          isExpanded: l,
          "aria-label": g["aria-label"],
          icon: c,
          isDisabled: d,
          isFullWidth: !0,
          children: T.find((b) => b.props.value === a)?.props.children || a || g["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ee, { children: y })
    }
  );
}, ia = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: o,
  maxHeight: s,
  width: u,
  toggleIcon: c,
  direction: p,
  selections: d,
  typeAheadAriaLabel: y,
  chipGroupComponent: g,
  chipGroupProps: C,
  footer: R,
  isDisabled: m,
  children: h,
  ...S
}) => {
  const [T, I] = E(""), [b, x] = E(0), F = J(), A = Dt.toArray(
    h
  ), B = () => {
    r?.(!S.isOpen);
  }, U = (M) => {
    const f = A[b];
    switch (r?.(!0), M.key) {
      case "Enter": {
        M.preventDefault(), l !== G.typeaheadMulti ? I(f.props.value) : I(""), n?.(f.props.value), r?.(!1), x(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        l === G.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        M.preventDefault();
        let k = 0;
        M.key === "ArrowUp" && (b === 0 ? k = A.length - 1 : k = b - 1), M.key === "ArrowDown" && (b === A.length - 1 ? k = 0 : k = b + 1), x(k);
        break;
      }
    }
  };
  return /* @__PURE__ */ v(
    Te,
    {
      ...S,
      onClick: B,
      onOpenChange: (M) => r?.(M),
      onSelect: (M, f) => {
        n?.(f || ""), a?.(""), I("");
      },
      maxMenuHeight: we(s),
      popperProps: { direction: p, width: we(u) },
      toggle: (M) => /* @__PURE__ */ t(
        he,
        {
          ref: M,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: c,
          isDisabled: m,
          isExpanded: S.isOpen,
          isFullWidth: !0,
          status: i === "error" ? ze.danger : void 0,
          children: /* @__PURE__ */ v(wt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              xt,
              {
                placeholder: o,
                value: l === G.typeahead && d ? d : T,
                onClick: B,
                onChange: (f, k) => {
                  I(k), a?.(k);
                },
                onKeyDown: (f) => U(f),
                autoComplete: "off",
                innerRef: F,
                role: "combobox",
                isExpanded: S.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": y,
                children: l === G.typeaheadMulti && Array.isArray(d) && (g || /* @__PURE__ */ t(Je, { ...C, children: d.map((f, k) => /* @__PURE__ */ t(
                  Ye,
                  {
                    onClick: (O) => {
                      O.stopPropagation(), n?.(f);
                    },
                    children: f
                  },
                  k
                )) }))
              }
            ),
            /* @__PURE__ */ t(St, { children: !!T && /* @__PURE__ */ t(
              V,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), I(""), a?.(""), F?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ee, { children: h }),
        R && /* @__PURE__ */ t(kn, { children: R })
      ]
    }
  );
};
var G = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(G || {});
const we = (e) => typeof e == "number" ? e + "px" : e, oa = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(la, { ...n }) : /* @__PURE__ */ t(ia, { ...n, variant: e }), gt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, o] = E(!1), [s, u] = E(""), c = a === "multiselect", p = (m, h) => {
    c ? h.value.includes(m) ? h.onChange(h.value.filter((S) => S !== m)) : Array.isArray(h.value) ? h.onChange([...h.value, m]) : h.onChange([m]) : h.onChange(m === h.value ? "" : m);
  }, d = l.validators?.options?.options || [], y = l.annotations?.inputOptionLabels || {}, g = l.annotations?.inputOptionLabelsI18nPrefix, C = (m) => te(e.t, y[m], m, g), R = (m) => d.filter(
    (h) => C(h).toLowerCase().includes(s.toLowerCase())
  ).map((h) => /* @__PURE__ */ t(
    Ge,
    {
      selected: m === h,
      value: h,
      children: C(h)
    },
    h
  ));
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    ie,
    {
      name: Y(l.name),
      defaultValue: "",
      control: r.control,
      render: ({ field: m }) => /* @__PURE__ */ t(
        oa,
        {
          toggleId: l.name,
          onToggle: (h) => o(h),
          onClear: () => p("", m),
          onSelect: (h) => {
            const S = h.toString();
            p(S, m), Array.isArray(m.value) || o(!1);
          },
          selections: c && Array.isArray(m.value) ? m.value.map((h) => C(h)) : C(m.value),
          variant: c ? G.typeaheadMulti : d.length >= 10 ? G.typeahead : G.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (h) => (u(h), R(m.value)),
          children: R(m.value)
        }
      )
    }
  ) });
}, sa = (e) => {
  const { form: n, attribute: r } = e, a = Re(r);
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Hr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Y(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a
    }
  ) });
}, K = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Re(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Se,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : te(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      ...n.register(Y(a.name))
    }
  ) });
}, Ue = {
  text: K,
  textarea: sa,
  select: gt,
  "select-radiobuttons": ft,
  multiselect: gt,
  "multiselect-checkboxes": ft,
  "html5-email": K,
  "html5-tel": K,
  "html5-url": K,
  "html5-number": K,
  "html5-range": K,
  "html5-datetime-local": K,
  "html5-date": K,
  "html5-month": K,
  "html5-time": K,
  "multi-input": ra
}, Za = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: o
}) => {
  const s = _(() => {
    if (!r.attributes)
      return [];
    const u = i ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: u.filter(
        (p) => p.group === c.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return s.length === 0 ? null : /* @__PURE__ */ t(
    Zr,
    {
      label: e("jumpToSection"),
      sections: s.filter((u) => u.attributes.length > 0).map(({ group: u, attributes: c }) => ({
        title: te(e, u.displayHeader, u.name) || e("general"),
        panel: /* @__PURE__ */ v("div", { className: "pf-v5-c-form", children: [
          u.displayDescription && /* @__PURE__ */ t(Ce, { className: "pf-v5-u-pb-lg", children: te(e, u.displayDescription, "") }),
          c.map((p) => /* @__PURE__ */ t(
            ca,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: o,
              attribute: p
            },
            p.name
          ))
        ] })
      }))
    }
  );
}, ca = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const o = n.watch(
    Y(i.name)
  ), s = _(() => ua(i), [i]), u = i.multivalued || pa(o) && i.annotations?.inputType === void 0 ? Ue["multi-input"] : Ue[s];
  return i.name === "locale" ? /* @__PURE__ */ t(
    na,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    u,
    {
      t: e,
      form: n,
      inputType: s,
      attribute: i,
      renderer: r
    }
  );
}, da = "text";
function ua(e) {
  if (Kt(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return ha(n) ? n : da;
}
const ha = (e) => typeof e == "string" && e in Ue, pa = (e) => Array.isArray(e) && e.length > 1, ma = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ v(
  "svg",
  {
    className: fr(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ v("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), yt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = E(!1);
  return /* @__PURE__ */ t(
    In,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (o) => i(o),
      toggle: (o) => /* @__PURE__ */ t(
        he,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: o,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(or, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(wn, { children: r })
    }
  );
};
function fa(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const el = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: o = !0,
    hasManageAccount: s = !0,
    hasUsername: u = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: p = [],
  toolbarItems: d,
  toolbar: y,
  ...g
}) => {
  const { t: C } = q(), R = [];
  s && R.push(
    /* @__PURE__ */ t(
      st,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), o && R.push(
    /* @__PURE__ */ t(st, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const m = e.idTokenParsed?.picture;
  return /* @__PURE__ */ v(xn, { ...g, children: [
    /* @__PURE__ */ t(Sn, { children: /* @__PURE__ */ t(Tn, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(sr, {}) }) }),
    /* @__PURE__ */ t(En, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ v(An, { children: [
      y,
      /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ v(Ve, { children: [
        d?.map((h, S) => /* @__PURE__ */ t(H, { align: { default: "alignRight" }, children: h }, S)),
        /* @__PURE__ */ t(
          H,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options",
                dropDownItems: [...p, R],
                title: u ? fa(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          H,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || p,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          H,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: m || i?.src ? /* @__PURE__ */ t(Rn, { src: m, alt: C("avatar"), ...i }) : /* @__PURE__ */ t(ma, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Ht = Xe("ErrorBoundaryContext", void 0), Wt = () => Ze(Ht);
class tl extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Ht.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const nl = ({ children: e, fallback: n }) => {
  const { error: r } = Wt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ga(e, n, r) {
  const { showBoundary: a } = Wt();
  le(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((o) => {
      i.aborted || n(o);
    }).catch((o) => {
      console.error(o), i.aborted || a(o);
    }), () => l.abort();
  }, r);
}
const ya = () => {
  const { t: e } = q();
  return /* @__PURE__ */ t(On, { children: /* @__PURE__ */ t(kt, { "aria-label": e("spinnerLoading") }) });
}, ba = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: o,
  icon: s,
  isDisabled: u = !1
}) => /* @__PURE__ */ v(Dn, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: cr }) : a && /* @__PURE__ */ t(ct, { icon: s || Mt }),
  /* @__PURE__ */ t(Fn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Pn, { children: n }),
  /* @__PURE__ */ v(Mn, { children: [
    i && /* @__PURE__ */ t(
      V,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: u,
        children: i
      }
    ),
    o && /* @__PURE__ */ t(Ln, { children: o.map((c) => /* @__PURE__ */ t(
      V,
      {
        "data-testid": `${c.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: c.type || Ie.secondary,
        onClick: c.onClick,
        isDisabled: u,
        children: c.text
      },
      c.text
    )) })
  ] })
] }), va = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: o,
  inputGroupOnEnter: s
}) => {
  const { t: u } = q(), [c, p] = E(""), d = (g) => {
    p(g.trim()), s?.(g.trim());
  }, y = (g) => {
    g.key === "Enter" && d(c);
  };
  return /* @__PURE__ */ v(W, { children: [
    /* @__PURE__ */ t(ke, { "data-testid": "table-toolbar", children: /* @__PURE__ */ v(Ve, { children: [
      i && /* @__PURE__ */ t(H, { children: /* @__PURE__ */ v(xe, { "data-testid": i, children: [
        l,
        o && /* @__PURE__ */ t(
          Bn,
          {
            "data-testid": "table-search-input",
            placeholder: o,
            "aria-label": u("search"),
            value: c,
            onChange: (g, C) => {
              p(C);
            },
            onSearch: () => d(c),
            onKeyDown: y,
            onClear: () => d("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(ke, { children: /* @__PURE__ */ t(Ve, { children: n }) }),
    /* @__PURE__ */ t(Nn, {}),
    a,
    /* @__PURE__ */ t(ke, { children: r })
  ] });
}, bt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: o,
  onPerPageSelect: s
}) => {
  const { t: u } = q(), c = Math.round(a / l);
  return /* @__PURE__ */ t(
    Vn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${u("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: p,
        lastIndex: d
      }) => /* @__PURE__ */ v("b", { children: [
        p,
        " - ",
        d
      ] }),
      itemCount: r + c * l,
      page: c + 1,
      perPage: l,
      onNextClick: (p, d) => i((d - 1) * l),
      onPreviousClick: (p, d) => o((d - 1) * l),
      onPerPageSelect: (p, d, y) => s(y - 1, d),
      variant: n
    }
  );
}, Ca = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: o,
  inputGroupOnEnter: s,
  ...u
}) => /* @__PURE__ */ t(
  va,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ v(W, { children: [
      r,
      /* @__PURE__ */ t(H, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, ...u }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(H, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, variant: "bottom", ...u }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: o,
    inputGroupOnEnter: s,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, vt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => /* @__PURE__ */ v(W, { children: [
  e.cells.map((l, i) => /* @__PURE__ */ t(re, { children: jt(l) ? l.title : l }, `cell-${i}`)),
  (r || a) && /* @__PURE__ */ t(re, { isActionCell: !0, children: /* @__PURE__ */ t(
    Cr,
    {
      items: r || a?.(e, {}),
      extraData: { rowIndex: n }
    }
  ) })
] }), ka = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function Ia({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: o,
  onCollapse: s,
  canSelectAll: u,
  canSelect: c,
  isNotCompact: p,
  isRadio: d,
  ...y
}) {
  const { t: g } = q(), [C, R] = E(i || []), [m, h] = E([]), S = _(
    () => pr(
      C,
      n.map((b) => b.data),
      "id"
    ),
    [C, n]
  );
  le(() => {
    if (u) {
      const b = document.getElementsByName("check-all").item(0);
      if (b) {
        const x = b;
        x.indeterminate = S.length < n.length && S.length > 0;
      }
    }
  }, [C, u, n]);
  const T = (b) => {
    R(b), o?.(b);
  }, I = (b, x) => {
    if (d) {
      const F = x ? [n[b].data] : [];
      T(F);
    } else if (b === -1) {
      const F = S.map(
        (A) => N(A, "id")
      );
      T(
        x ? [...C, ...n.map((A) => A.data)] : C.filter(
          (A) => !F.includes(N(A, "id"))
        )
      );
    } else
      T(x ? [...C, n[b].data] : C.filter(
        (F) => N(F, "id") !== n[b].data.id
      ));
  };
  return /* @__PURE__ */ v(
    gr,
    {
      ...y,
      variant: p ? void 0 : yr.compact,
      "aria-label": g(l),
      children: [
        /* @__PURE__ */ t(br, { children: /* @__PURE__ */ v(ve, { children: [
          s && /* @__PURE__ */ t(Pe, { screenReaderText: g("expandRow") }),
          u && /* @__PURE__ */ t(
            Pe,
            {
              screenReaderText: g("selectAll"),
              select: d ? void 0 : {
                onSelect: (b, x) => {
                  I(-1, x);
                },
                isSelected: S.length === n.length
              }
            }
          ),
          e.map((b) => /* @__PURE__ */ t(
            Pe,
            {
              screenReaderText: g("expandRow"),
              className: b.transforms?.[0]().className,
              children: g(b.displayKey || b.name)
            },
            b.displayKey || b.name
          ))
        ] }) }),
        s ? n.map((b, x) => /* @__PURE__ */ t(ut, { children: x % 2 === 0 ? /* @__PURE__ */ v(ve, { children: [
          /* @__PURE__ */ t(
            re,
            {
              expand: n[x + 1].cells.length === 0 ? void 0 : {
                isExpanded: m[x] ?? !1,
                rowIndex: x,
                expandId: "expandable-row-",
                onToggle: (F, A, B) => {
                  s(B, A);
                  const U = [...m];
                  U[x] = B, h(U);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ v(ve, { isExpanded: m[x - 1] ?? !1, children: [
          /* @__PURE__ */ t(re, {}),
          /* @__PURE__ */ t(re, { colSpan: e.length, children: /* @__PURE__ */ t(vr, { children: /* @__PURE__ */ t(ka, { row: b }) }) })
        ] }) }, x)) : /* @__PURE__ */ t(ut, { children: n.map((b, x) => /* @__PURE__ */ v(ve, { isExpanded: m[x], children: [
          c && /* @__PURE__ */ t(
            re,
            {
              select: {
                rowIndex: x,
                onSelect: (F, A, B) => {
                  I(B, A);
                },
                isSelected: !!C.find(
                  (F) => N(F, "id") === b.data.id
                ),
                variant: d ? "radio" : "checkbox"
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }, x)) })
      ]
    }
  );
}
function wa({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: o,
  detailColumns: s,
  isRowDisabled: u,
  loader: c,
  columns: p,
  actions: d,
  actionResolver: y,
  searchTypeComponent: g,
  toolbarItem: C,
  subToolbar: R,
  emptyState: m,
  icon: h,
  isSearching: S = !1,
  ...T
}) {
  const { t: I } = q(), [b, x] = E([]), [F, A] = E(), [B, U] = E(), [M, f] = E(!1), [k, O] = Nt(
    localStorage,
    "pageSize",
    10
  ), [D, oe] = E(k), [$, se] = E(0), [j, Oe] = E(""), tt = J(), [fe, Gt] = E(0), nt = J(), rt = () => Gt(fe + 1), zt = Rt(), at = (w, P) => w.map((L) => {
    if ("cellFormatters" in L) {
      const X = N(P, L.name);
      return L.cellFormatters?.reduce((ce, ye) => ye(ce), X);
    }
    if (L.cellRenderer) {
      const X = L.cellRenderer;
      return { title: /* @__PURE__ */ t(X, { ...P }) };
    }
    return N(P, L.name);
  }), lt = (w) => {
    const P = (L) => s?.[0]?.enabled?.(L);
    return w.map((L, X) => {
      const ce = u ? u(L) : !1, ye = [
        {
          data: L,
          disableSelection: ce,
          disableActions: ce,
          selected: !!b.find((Zt) => N(Zt, "id") === N(L, "id")),
          isOpen: P(L) ? !1 : void 0,
          cells: at(p, L)
        }
      ];
      return s && ye.push({
        parent: X * 2,
        cells: P(L) ? at(s, L) : []
      }), ye;
    }).flat();
  }, De = (w) => ["string", "number"].includes(typeof w) ? w.toString() : w instanceof Array ? w.map(De).join("") : typeof w == "object" ? De(
    Kn(w.title) ? w.title.props : Object.values(w)
  ) : "", it = _(
    () => j === "" || r ? void 0 : lt(B || []).filter(
      (w) => w.cells.some(
        (P) => P && De(P).toLowerCase().includes(j.toLowerCase())
      )
    ).slice($, $ + D + 1),
    [j, $, D]
  );
  ga(
    async () => {
      f(!0);
      const w = tt.current === "" && j !== "";
      return w && se(0), tt.current = j, typeof c == "function" ? fe === nt.current && B ? B : await c(w ? 0 : $, D + 1, j) : c;
    },
    (w) => {
      nt.current = fe, r || (U(w), w.length > $ ? w = w.slice($, $ + D + 1) : se(0));
      const P = lt(w);
      A(P), f(!1);
    },
    [
      fe,
      $,
      D,
      j,
      typeof c != "function" ? c : void 0
    ]
  );
  const Jt = () => d && mr(d).map((w, P) => (delete w.onRowClick, w.onClick = async (L, X) => {
    await d[P].onRowClick(
      (it || F)[X].data
    ) && (r || Oe(""), rt());
  }, w)), Yt = (w, P) => {
    Q[P].isOpen = w, A([...Q]);
  }, Q = it || F, ge = !Q || Q.length === 0, Fe = j !== "" || S, Qt = s ? D * 2 : D, Xt = s ? (Q?.length || 0) / 2 : Q?.length || 0;
  return /* @__PURE__ */ v(W, { children: [
    (!ge || Fe) && /* @__PURE__ */ v(
      Ca,
      {
        id: zt,
        count: Xt,
        first: $,
        max: D,
        onNextClick: se,
        onPreviousClick: se,
        onPerPageSelect: (w, P) => {
          se(w), oe(P), O(P);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Oe,
        inputGroupPlaceholder: I(n || ""),
        searchTypeComponent: g,
        toolbarItem: /* @__PURE__ */ v(W, { children: [
          C,
          " ",
          /* @__PURE__ */ t(H, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(H, { children: /* @__PURE__ */ v(V, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(dr, {}),
            " ",
            I("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !M && !ge && /* @__PURE__ */ t(
            Ia,
            {
              ...T,
              canSelectAll: l,
              canSelect: !!a,
              selected: b,
              onSelect: (w) => {
                x(w), a?.(w);
              },
              onCollapse: s ? Yt : void 0,
              actions: Jt(),
              actionResolver: y,
              rows: Q.slice(0, Qt),
              columns: p,
              isNotCompact: i,
              isRadio: o,
              ariaLabelKey: e
            }
          ),
          !M && ge && Fe && /* @__PURE__ */ t(
            ba,
            {
              hasIcon: !0,
              icon: h,
              isSearchVariant: !0,
              message: I("noSearchResults"),
              instructions: I("noSearchResultsInstructions"),
              secondaryActions: S ? [] : [
                {
                  text: I("clearAllFilters"),
                  onClick: () => Oe(""),
                  type: Ie.link
                }
              ]
            }
          )
        ]
      }
    ),
    M && /* @__PURE__ */ t(ya, {}),
    !M && ge && !Fe && m
  ] });
}
const xa = ({ link: e, organization: n }) => {
  const { t: r } = q();
  return /* @__PURE__ */ t(kr, { wrapModifier: "truncate", children: /* @__PURE__ */ v(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      _n,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Sa = (e) => {
  const { t: n } = q();
  return /* @__PURE__ */ t(
    Je,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Ye, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, rl = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: o,
  deleteLabel: s = "delete",
  link: u,
  children: c
}) => {
  const { t: p } = q();
  return /* @__PURE__ */ t(
    wa,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: o ? [
        {
          title: p(s),
          onRowClick: o
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (d) => /* @__PURE__ */ t(xa, { link: u, organization: d })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Sa
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: c
    }
  );
};
export {
  Dr as AlertProvider,
  Ka as ContinueCancelModal,
  nl as ErrorBoundaryFallback,
  tl as ErrorBoundaryProvider,
  Fr as ErrorPage,
  _t as FormErrorText,
  zr as FormPanel,
  Xa as FormSubmitButton,
  Br as Help,
  qt as HelpItem,
  Qa as IconMapper,
  wa as KeycloakDataTable,
  el as KeycloakMasthead,
  qa as KeycloakProvider,
  oa as KeycloakSelect,
  ya as KeycloakSpinner,
  Hr as KeycloakTextArea,
  ba as ListEmptyState,
  Ua as NumberControl,
  rl as OrganizationTable,
  Ca as PaginatingTableToolbar,
  Ha as PasswordControl,
  $t as PasswordInput,
  Zr as ScrollForm,
  $r as SelectControl,
  de as SelectVariant,
  za as SwitchControl,
  va as TableToolbar,
  Ja as TextAreaControl,
  Ya as TextControl,
  Za as UserProfileFields,
  Wa as beerify,
  Xe as createNamedContext,
  Ur as debeerify,
  Tr as generateId,
  xr as getErrorDescription,
  wr as getErrorMessage,
  $a as getInjectedEnvironment,
  Sr as getNetworkErrorDescription,
  Lt as getNetworkErrorMessage,
  Er as isDefined,
  Ga as isUserProfileError,
  te as label,
  Xr as mainPageContentId,
  ja as setUserProfileServerError,
  Va as useAlerts,
  _a as useEnvironment,
  Wt as useErrorBoundary,
  ga as useFetch,
  Lr as useHelp,
  Ze as useRequiredContext,
  Ar as useSetTimeout,
  Nt as useStoredState
};
